// @flow

import React, { Component }           from 'react';
import { connect }                    from 'react-redux';
import { getTranslate }               from 'react-localize-redux';
import { getOutboundAffiliates,
         setActiveOutboundAffiliate } from 'actions/outboundAffiliates';
import Tabs                           from 'components/main/specialDeals/tabs';

class SpecialDeals extends Component {
  componentDidMount() {
    const { dispatch, categories } = this.props;
    if (!categories.length) { dispatch(getOutboundAffiliates()) };
  }

  handleActiveCategory(id) {
    const { dispatch, categories } = this.props;
    const activeAffiliate = categories.find(item => item.id === id)
    dispatch(setActiveOutboundAffiliate(activeAffiliate))
  }

  render() {
    const { translate, categories, activeCategory } = this.props;
    return (
      <Tabs
        translate={translate}
        categories={categories}
        activeCategory={activeCategory}
        handleActiveCategory={this.handleActiveCategory.bind(this)}
      />
    )
  }
}

const mapStateToProps = state => ({
  translate        : getTranslate(state.locale),
  user             : state.user,
  categories       : state.outboundAffiliates.categories,
  activeCategory   : state.outboundAffiliates.activeCategory
});

export default connect(mapStateToProps)(SpecialDeals);



// WEBPACK FOOTER //
// ./src/containers/specialDeals/index.js